/**
 * Created by mac on 7/24/17.
 */

const KingsCupMarksView = cc.Node.extend({
    avoidView: "KingsCupMarksView",

    ctor: function () {
        this._super();

        this.mission = Game.currentGame.kingsCupMission;
        this.amount = Game.currentGame.rewards.kingsCup || 0;
        this.setLocalZOrder(10);

        this.setAnchorPoint(0.5, 0.5);

        this.background = this.createBackground();

        this.icon = this.createIcon();
        this.text = this.createText();

        cleverapps.eventBus.on("kingsCupMarkArrived", this.createListener(this.runCollectAnimation.bind(this)), this);

        cleverapps.tooltipManager.create(this, {
            text: Messages.get("CloversTooltip"),
            location: cleverapps.UI.Tooltip.LOCATION_BELOW,
            control: "kingsCupMarksViewTooltip",
            interactiveScale: true
        });

        cleverapps.aims.registerTarget(`mission_reward${this.mission.type}`, this.icon, {
            flyingUnderShadow: true,
            controls: ["rewardElementKingsCupMarks"]
        });

        const styles = cleverapps.styles.KingsCupMarksView;

        this.setContentSize2(styles);
        this.background.setContentSize2(styles);

        this.icon.setAlignment(styles.icon);
        this.text.setAlignment(styles.text);

        this.onResize();
    },

    onResize: function () {
        if (!Game.currentGame) {
            return;
        }

        const styles = cleverapps.styles.KingsCupMarksView;

        this.setScale(styles.scale[cleverapps.resolution.mode]);
        this.setAlignment(styles.position);
    },

    createBackground: function () {
        const background = cleverapps.UI.createScale9Sprite(bundles.reward_element.frames.reward_element_bg_png, cleverapps.UI.Scale9Rect.TwoPixelXY);
        background.setAnchorPoint(0, 0);
        this.addChild(background);
        return background;
    },

    createIcon: function () {
        const styles = cleverapps.styles.KingsCupMarksView;

        const icon = new cc.Sprite(this.mission.getIcon());
        this.addChild(icon);
        cleverapps.UI.fitToBox(icon, styles.icon);
        icon.baseScale = icon.scale;

        return icon;
    },

    createText: function () {
        const styles = cleverapps.styles.KingsCupMarksView;

        const text = this.text = cleverapps.UI.generateImageText(
            this.getTextString(),
            cleverapps.styles.FONTS.KINGSCUP_MARKS_TEXT
        );
        this.addChild(text);
        text.setAlignment(styles.text);

        return text;
    },

    getTextString: function () {
        return this.amount;
    },

    runCollectAnimation: function (value) {
        this.amount += value;
        this.stopAllActions();

        const styles = cleverapps.styles.KingsCupMarksView;

        this.icon.runAction(new cc.Sequence(
            new cc.CallFunc(() => {
                const sparks = new cleverapps.Spine(bundles.animations_library.jsons.sparks_json);
                sparks.setSkin("yellow");
                sparks.setAnimation(0, "single", false);
                sparks.setCompleteListenerRemove();

                this.addChild(sparks, 0);
                sparks.setAlignment(this.icon.getPositionX() + styles.sparks.x, this.icon.getPositionY() + styles.sparks.y);
            }),
            cleverapps.effects.fireAction("tournament.element.collected"),
            new cc.ScaleTo(0.15, this.icon.baseScale * 1.1),
            new cc.CallFunc(() => {
                this.text.setString(this.getTextString());
            }),
            new cc.ScaleTo(0.15, this.icon.baseScale)
        ));
    }
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    KINGSCUP_MARKS_TEXT: {
        name: "default",
        size: 40
    }
});

KingsCupMarksView.isAvailable = function () {
    return cleverapps.config.type === "board";
};

cleverapps.styles.KingsCupMarksView = {
    width: 150,
    height: 61,

    scale: [1, 1, 1],

    position: [
        {
            x: { align: "left", dx: 40 },
            y: { align: "top", dy: -150 }
        },
        {
            x: { align: "left", dx: 236 },
            y: { align: "top", dy: -150 }
        },
        {
            x: { align: "left", dx: 250 },
            y: { align: "top", dy: -150 }
        }
    ],

    icon: {
        x: { align: "center" },
        y: { align: "center" },

        width: 100,
        height: 100
    },

    text: {
        x: { align: "center", dx: 20 },
        y: { align: "center" }
    },

    sparks: {
        x: 0,
        y: 0
    }
};
